import React from 'react';
import Bluebird from 'bluebird';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Mutation, MutationComponentOptions } from '@apollo/client/react/components';

import viewer, { ViewerConsumer } from 'four-nets/user/viewer/viewer';

import mutation, {
    AcceptFriendInvitationWithKeyMutation,
    AcceptFriendInvitationWithKeyMutationVariables,
} from './mutations/accept-with-key.graphql';

interface Props extends RouteComponentProps<{ confirmationKey: string }> {}
interface State {
    to?: string;
    loading?: boolean;
}

class Confirmation extends React.PureComponent<Props, State> {
    acceptFn!: MutationComponentOptions<
        AcceptFriendInvitationWithKeyMutation,
        AcceptFriendInvitationWithKeyMutationVariables
    >;
    promise?: Bluebird<any>;
    state = {} as State;

    componentDidMount() {
        this.attemptConfirmation();
    }

    componentDidUpdate() {
        this.attemptConfirmation();
    }

    attemptConfirmation = () => {
        if (this.acceptFn && !this.state.loading) {
            this.setState({ loading: true });
            const {
                match: {
                    params: { confirmationKey },
                },
            } = this.props;

            this.acceptFn({ variables: { input: { confirmationKey } } })
                .then(result => {
                    if (
                        result &&
                        result.data &&
                        !result.errors &&
                        result.data.acceptFriendInvitation &&
                        result.data.acceptFriendInvitation.user &&
                        result.data.acceptFriendInvitation.user.username
                    ) {
                        this.setState({ to: `/blog/${result.data.acceptFriendInvitation.user.username}` });
                    } else {
                        this.setState({ to: '/' });
                    }
                })
                .catch(err => {
                    // console.error(err);
                    this.setState({ to: '/' });
                })
                .finally(() => {
                    this.setState({ loading: false });
                });
        }
    };

    render() {
        const { to } = this.state;

        return viewer ? (
            <Mutation<AcceptFriendInvitationWithKeyMutation, AcceptFriendInvitationWithKeyMutationVariables>
                mutation={mutation}
            >
                {acceptFn => {
                    this.acceptFn = acceptFn;
                    return (
                        <ViewerConsumer>{({ viewer }) => (viewer && to ? <Redirect to={to} /> : null)}</ViewerConsumer>
                    );
                }}
            </Mutation>
        ) : null;
    }
}

export default Confirmation;
